module.exports = __webpack_public_path__ + "0ddac96f83d1854811305f3da8c09f72.svg";